import { Controller } from "@hotwired/stimulus";
import { useDebounce } from "stimulus-use";

export default class extends Controller {
  static debounces = ["fetchSuppliers"];
  static targets = ["SupplierSearchInput", "SupplierDropdown", "SupplierList"];
  static values = {
    handlingController: String,
  };

  connect() {
    this.element[this.identifier] = this;
    useDebounce(this);

    this.SupplierSearchInputTarget.addEventListener("input", (e) => {
      this.fetchSuppliers(e.target.value);
    });

    this.SupplierListTarget.addEventListener("click", (e) => {
      if (e.target.tagName === "LI") {
        const supplierData = JSON.parse(decodeURIComponent(escape(atob(e.target.getAttribute("data-supplier")))));
        this.handleSupplierSelect(supplierData);
        this.SupplierDropdownTarget.classList.add("hidden");
      }
    });
  }

  onKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  async fetchSuppliers(search) {
    const response = await fetch(`/admin/seed_suppliers/search?query=${search}`, {
      headers: { Accept: "application/json" },
    });
    const data = await response.json();
    this.updateSupplierDropdown(data);
  }

  updateSupplierDropdown(suppliers) {
    console.log("suppliers", suppliers);
    this.SupplierListTarget.innerHTML = suppliers.map((supplier) => `<li class="p-2 cursor-pointer hover:bg-gray-200" data-id="${supplier.id}" data-supplier='${btoa(unescape(encodeURIComponent(JSON.stringify(supplier))))}'>${supplier.id} - ${supplier.name}</li>`).join("");
    if (suppliers.length > 0) {
      this.SupplierDropdownTarget.classList.remove("hidden");
    } else {
      this.SupplierDropdownTarget.classList.add("hidden");
    }
  }

  handleSupplierSelect(supplier) {
    if (this.hasHandlingControllerValue) {
      let controller;
      for (const ctrl of this.application.controllers) {
        if (ctrl.identifier === this.handlingControllerValue) {
          const controllerIdentifiers = ctrl.element.getAttribute("data-controller").split(" ");
          if (controllerIdentifiers.includes(this.handlingControllerValue)) {
            controller = ctrl;
            console.log(controller);
            break; // If you want to stop after finding the first match
          }
        }
      }
      if (controller) {
        controller.handleSupplierSelect(supplier);
      } else {
        console.log("Controller not found");
      }
    } else {
      // Your existing code for handling the selected supplier and updating the form fields
      console.log("supplier: ", supplier);
      if (this.hasSupplierNameInputTarget) {
        this.SupplierNameInputTarget.value = supplier.name;
      }
      if (this.hasSupplierStreetInputTarget) {
        this.SupplierStreetInputTarget.value = supplier.address;
      }
      if (this.hasSupplierCityInputTarget) {
        this.SupplierCityInputTarget.value = supplier.city;
      }
      if (this.hasSupplierStateInputTarget) {
        this.SupplierStateInputTarget.value = supplier.state;
      }
      if (this.hasSupplierZipInputTarget) {
        this.SupplierZipInputTarget.value = supplier.zipcode;
      }
      if (this.hasSupplierEmailInputTarget) {
        this.SupplierEmailInputTarget.value = "corn@hybrid85.com";
      }
      if (this.hasSupplierPhoneInputTarget) {
        this.SupplierPhoneInputTarget.value = "4023824270";
      }
    }
  }
}
